export enum AccountSettingsSectionEnum {
  Notification = 'notification-settings',
  Security = 'security',
}
